import React, { useEffect } from 'react';
// Changed HashRouter to BrowserRouter to remove the '#' from the URL
import { BrowserRouter as Router, Routes, Route, Outlet, Navigate, useLocation } from 'react-router-dom';

// Brand Assets
import logo from './assets/logo.png';

// Components & Layout
import Header from './components/Header';
import Footer from './components/Footer';

// Public Pages
import HomeContent from './pages/Home';
import AboutUs from './pages/AboutUs';
import Treatments from './pages/Treatments';
import Library from './pages/Library';
import OngoingProjects from './pages/OngoingProjects';
import CompletedProjects from './pages/CompletedProjects';
// Commenting these out since they are currently under construction
// import Gallery from './pages/Gallery';
// import Blog from './pages/Blog';

// FIXED: Changed the import path casing to match typical Linux strict case-sensitivity.
// Make sure your actual file is named exactly "Emagazine.js".
import EMagazine from './pages/EMagazine';

import Contact from './pages/Contact';
import OurCommunity from './pages/OurCommunity';
import UnderConstruction from './pages/UnderConstruction'; // Added UnderConstruction import

// Admin / Portal
import MediStore from './admin/MediStore';
import Login from './admin/Login';
import InventoryList from './admin/pages/InventoryList';
import PatientsList from './admin/pages/PatientsList';
import NewPatient from './admin/pages/NewPatient';

// --- SCROLL TO TOP COMPONENT ---
// This component forces the window to scroll to the top every time the route changes
const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};

// --- LAYOUTS ---
const WebsiteLayout = () => (
    <div className="flex flex-col min-h-screen bg-[#FDFBF7]">
        <Header />
        <main className="flex-grow">
            <Outlet />
        </main>
        <Footer />
    </div>
);

// --- PROTECTED ROUTE GUARD ---
const ProtectedRoute = () => {
    const isAuthenticated = localStorage.getItem('isLoggedIn') === 'true';
    return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

function App() {
    return (
        <Router>
            {/* The ScrollToTop component must sit right inside the Router */}
            <ScrollToTop />

            <Routes>
                {/* 1. Public Website Routes */}
                <Route element={<WebsiteLayout />}>
                    <Route path="/" element={<Navigate to="/home" replace />} />

                    <Route path="/home" element={<HomeContent />} />
                    {/* Note: Ensure the path exactly matches what you want in the URL.
                        Google indexed "/about", so you might want to change this from "/Aboutus" to "/about" */}
                    <Route path="/aboutus" element={<AboutUs />} />
                    <Route path="/treatments" element={<Treatments />} />
                    <Route path="/library" element={<Library />} />

                    {/* Project Routes */}
                    <Route path="/projects/annual" element={<OngoingProjects />} />
                    <Route path="/projects/completed" element={<CompletedProjects />} />

                    {/* Media Routes - Updated to UnderConstruction */}
                    <Route path="/gallery" element={<UnderConstruction />} />
                    <Route path="/blog" element={<UnderConstruction />} />

                    <Route path="/emagazine" element={<EMagazine />} />

                    <Route path="/contact" element={<Contact />} />
                    <Route path="/OurCommunity" element={<OurCommunity />} />

                    <Route path="/login" element={<Login />} />
                </Route>

                {/* 2. Protected Admin Dashboard */}
                <Route element={<ProtectedRoute />}>
                    <Route path="/store" element={<MediStore />}>
                        <Route index element={<InventoryList />} />
                        <Route path="patients-list" element={<PatientsList />} />
                        <Route path="new-patient" element={<NewPatient />} />
                    </Route>
                </Route>

                {/* Catch-all route */}
                <Route path="*" element={<Navigate to="/home" replace />} />
            </Routes>
        </Router>
    );
}

export default App;